import styled from 'styled-components';

export const CardRows = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1300px;
  width: 100%;
`;
